module.exports = __webpack_public_path__ + "static/website-banner-6489dca55a289102f746d814aaa4ec87.jpg";